import { Route } from '@angular/router';
import { authGuard, publicOnlyGuard } from '@shared-data-access';

export const appRoutes: Route[] = [
  // Ruta por defecto - Redireccionar a login
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  
  // Ruta de autenticación - Login (SIN layout)
  {
    path: 'login',
    canActivate: [publicOnlyGuard],
    loadComponent: () => 
      import('./features/auth/login/login.component').then(m => m.LoginComponent)
  },
  
  // Rutas con layout (dashboard, módulos, etc.)
  {
    path: 'app',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./layout-wrapper.component').then(m => m.LayoutWrapperComponent),
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent)
      },
      {
        path: 'tickets',
        loadComponent: () =>
          import('./features/tickets/tickets.component').then(
            (m) => m.TicketsComponent,
          ),
      },
      {
        path: 'asesores',
        loadComponent: () =>
          import('./features/advisors/advisors.component').then(
            (m) => m.AdvisorsComponent,
          ),
      },
      {
        path: 'reportes',
        loadComponent: () =>
          import('./features/reports/reports.component').then(
            (m) => m.ReportsComponent,
          ),
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('./features/profile/profile.component').then(
            (m) => m.ProfileComponent,
          ),
      },
      {
        path: 'change-password',
        loadComponent: () =>
          import('./features/change-password/change-password.component').then(
            (m) => m.ChangePasswordComponent,
          ),
      },
      {
        path: 'chat/:id',
        data: { kind: 'staff' },
        loadComponent: () =>
          import('@shared-data-access/services/inbox/chat-thread.component').then(
            (m) => m.ChatThreadComponent,
          ),
      },
      {
        path: 'support-chats',
        loadComponent: () =>
          import('./features/support-chats/support-chats.component').then(
            (m) => m.SupportChatsComponent,
          ),
      },
      {
        path: 'support-chats/:id',
        data: { kind: 'support' },
        loadComponent: () =>
          import('@shared-data-access/services/inbox/chat-thread.component').then(
            (m) => m.ChatThreadComponent,
          ),
      },
    ]
  },
  
  // Ruta 404 - Redireccionar a login (temporalmente)
  {
    path: '**',
    redirectTo: 'login'
  }
];
